import type { ClientEnvironment } from "~~/package/utils/ClientEnvironmentUtil";

/**
 * ASMT-PROCTOR-16 (TSK-11692) — 응시 환경 진입 차단 / 점검 실패 운영팀 알림 요청.
 *
 * 평가명·응시자 정보는 서버가 DB 에서 채운다. 클라이언트는 사실 관계(차단 판정, 실패 항목·사유)만 보낸다
 * — 응시자가 조작한 문자열이 운영 채널에 그대로 게시되지 않도록.
 */
export enum AssessmentEnvironmentEventType {
  /** 디바이스 차단 등으로 평가 시작 페이지 진입 자체가 막힌 경우. */
  BLOCKED = "BLOCKED",
  /** 응시 환경 점검(화면 공유 / 카메라 / 마이크 / 화면 녹화)이 실패한 경우. */
  CHECK_FAILED = "CHECK_FAILED",
}

export default interface ProSkillAssureEnvironmentReportRequest {
  eventType: AssessmentEnvironmentEventType;
  /** BLOCKED 일 때의 판정 디바이스 (PHONE / TABLET). */
  deviceKind?: string;
  /** CHECK_FAILED 일 때 실패한 점검 항목 키 목록 (예: SCREEN_SHARE, CAMERA, MICROPHONE, SCREEN_RECORDING). */
  failedItems?: string[];
  /** 실패 사유 원인 문자열 (예: NotAllowedError, NotFoundError, TIMEOUT). */
  failureReason?: string;
  /**
   * REQ-313 추가 요구 — 브라우저·기기/OS(·Proctive 버전). 운영팀은 이것으로 안내 방향을 정한다.
   * 호출부가 채우지 않는다 — `useProSkillAssureService.reportEnvironmentEvent` 가 한 곳에서 붙인다.
   */
  clientEnvironment?: ClientEnvironment;
}
